﻿document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');

    if (document.getElementById('navbar')) {
        document.addEventListener('scroll', () => {
            if (window.scrollY === 0) {
                $navbar.classList.add('is-spaced');
            }
            else {
                $navbar.classList.remove('is-spaced');
            }
        });
    }
});